var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshForChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refresh-cw-02"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 2.33333V5.83333H9.33329",
    fill: "#00282B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.16663 11.6667V8.16667H4.66663",
    fill: "#00282B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.16663 8.16667C1.16663 8.16667 1.2374 8.66206 3.28765 10.7123C5.3379 12.7626 8.66202 12.7626 10.7123 10.7123C11.4387 9.9859 11.9077 9.09958 12.1194 8.16667M1.16663 8.16667V11.6667M1.16663 8.16667H4.66663M12.8333 5.83333C12.8333 5.83333 12.7625 5.33794 10.7123 3.28769C8.66202 1.23744 5.3379 1.23744 3.28765 3.28769C2.56124 4.0141 2.0922 4.90042 1.88053 5.83333M12.8333 5.83333V2.33333M12.8333 5.83333H9.33329",
    stroke: "#00282B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshForChat);
export default __webpack_public_path__ + "static/media/refresh_for_chat.e647eb1e02bc8ab6fe562162a7340d93.svg";
export { ForwardRef as ReactComponent };